import { useDateFromSearchParams, useResourceOpportunities } from "@/helpers/useTimeHooks";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { ResourceType } from "@/pages/explorer/types";
import { RelativeComponentLoader } from "@/components/loader";
import { InsightSection } from "@/pages/query/components";

export function BiReportsOpportunities({
  rk,
  instanceId,
  helperText,
}: {
  rk: string;
  instanceId: string | null | undefined;
  helperText: string;
}) {
  const { startDate, endDate, onUpdate: onDateRangeChange } = useDateFromSearchParams();
  const { searchParams, updateSearchParamsByKey } = useFiltersBySearchParams();
  const { data: opportunities, isFetching } = useResourceOpportunities({
    resourceUri: rk,
    resourceType: ResourceType.Dashboard,
    instanceId: instanceId ?? undefined,
  });
  const selectedOpportunityId = searchParams.get("opportunityId");
  const setSelectedOpportunityId = (v: string) => updateSearchParamsByKey({ opportunityId: v });

  if (isFetching) {
    return <RelativeComponentLoader componentHeight={20} label={"Loading Opportunities..."} />;
  }

  return (
    <InsightSection
      opportunities={opportunities?.data ?? []}
      selectedOpportunityId={selectedOpportunityId}
      setOpportunityId={setSelectedOpportunityId}
      totalRuns={""}
      startDate={startDate}
      endDate={endDate}
      onDateRangeChange={onDateRangeChange}
      description={helperText}
    />
  );
}
